<template>
  <div>
    <label class="label" :class="{ 'is-verified': !!verified[field.name] }">{{ label + (field.is_required ? ' *' : '') }}</label>
    <!-- <input type="checkbox" :checked="value.consented" :disabled="disabled || readonly || verified" @input="onToggle" /> -->
    <b-checkbox :checked="value.consented" :disabled="disabled || readonly || verified" @input="onToggle">
      {{ label }}
    </b-checkbox>
    <p v-if="description" class="help">{{ description }}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    vid: {
      type: String,
      default: ''
    },
    rules: {
      type: [Object, String],
      default: ''
    },
    // must be included in props
    value: {
      type: null,
      default: () => ({ consented: false })
    },
    field: {
      type: Object,
      default: () => ({})
    },
    label: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    verified: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      user: 'authentication/user'
    })
  },

  methods: {
    onToggle(checked) {
      this.value.consented = checked;
      this.value.consented_at = new Date();
      this.value.consented_by = this.user.email;
      this.$emit('input', this.value);
    }
  }
};
</script>
